import React from "react";
import Button from "../../../../components/form-control/Button";
import usePolicy from "../../../../hooks/policyHook";
import { Policy } from "../../../../models/policy/Policy";
import { FleetPolicy } from "../../../../models/policy/FleetPolicy";
import { POLICY_REVIEW_STATES } from "../../../../resources/enums";
import { IReviewPolicyDTO } from "../../../../resources/interfaces";
import { isFleetPolicy, showToast } from "../../../../utils/miscFunctions";

const SubmitForApproval = ({ policy, onSubmitted, onCancel }: { policy: Policy | FleetPolicy | undefined; onSubmitted: () => void; onCancel: () => void }) => {
  const { reviewPolicy } = usePolicy();

  const [submitting, setSubmitting] = React.useState<boolean>(false);

  const submitPolicy = async () => {
    setSubmitting(true);

    const payload: IReviewPolicyDTO = {
      reason: "",
      reviewStage: POLICY_REVIEW_STATES.IN_APPROVAL
    }

    try {
      const response: any = isFleetPolicy(policy) ? await reviewPolicy(policy?.fleetNumber ?? "", payload) : await reviewPolicy(policy?.ref ?? "", payload)

      if (response) {
        showToast.success(response?.message || "Good job. Policy submitted for approval successfully.")
        onSubmitted();
      }
    } catch (error: any) {
      showToast.error(error?.description || "Failed to submit policy for approval. Please try again later.");
    } finally {
      setSubmitting(false);
    }
  }


  return (
    <div className="bg-white rounded-xl">
      <div className="p-4 space-y-10">
        <div className="pt-6">
          <p>
            By submitting this policy, you agree that all of the details provided by the
            policy&apos;s owner is accurate as of this day. Do you agree to submit this?
          </p>
        </div>

        <div className="w-full flex gap-4 mt-6 !mb-4">
          <Button
            type="button"
            label="Cancel"
            onClick={onCancel}
            bgColor='secondary'
                  fullWidth
          // loading={submitting}
          // disabled={submitting}
          />
          <Button
            label="Submit"
            onClick={submitPolicy}
            bgColor='primary'
              fullWidth
            loading={submitting}
            disabled={submitting}
          />
        </div>
      </div>
    </div>
  );
};

export default SubmitForApproval;